import { useAuth } from '../../_hooks/use-auth'
import { useQuickPassProfile } from '../../_hooks/use-quickpass-profile'
import { buildInitials, pickGradientFor } from './helpers'
import { AvatarRing } from './styled'
import { RenterAvatarProps } from './types'

/**
 * Circular avatar showing the renter's initials over a deterministic
 * gradient. The gradient is seeded from the QuickPass user id so the
 * same renter always gets the same colours across loads.
 *
 * @param {RenterAvatarProps} props
 * @returns {JSX.Element}
 */
const RenterAvatar = ({ size = 'md' }: RenterAvatarProps): JSX.Element => {
  const { quickPassUser } = useAuth()
  const { profile } = useQuickPassProfile()

  const seed = quickPassUser?.id ?? 'guest'
  const [fromColor, toColor] = pickGradientFor(seed)
  const initials = buildInitials(
    profile?.firstName ?? '',
    profile?.lastName ?? '',
  )

  return (
    <AvatarRing
      size={size}
      style={{
        background: `linear-gradient(135deg, ${fromColor} 0%, ${toColor} 100%)`,
      }}
      aria-label={`Avatar for ${initials}`}
    >
      {initials}
    </AvatarRing>
  )
}

export default RenterAvatar
